import type { FC } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { Pages } from "./Pages";

interface Props {
  emailRegex: string;
  treatmentPlanTerm: string;
  currentCountry: string;
  csuid: string;
  flippers: Flipper[];
  roleId: string;
  storeId: string;
  e2e: boolean;
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  newSSOErrors?: string;
  isPreview?: boolean;
  isStoreOwner: boolean;
}

const StoreLandingEntryPoint: FC<Props> = ({
  emailRegex,
  treatmentPlanTerm,
  currentCountry,
  csuid,
  flippers,
  roleId,
  storeId,
  e2e,
  patientAttributes,
  additionalAttributes,
  newSSOErrors,
  isPreview,
  isStoreOwner,
}) => {
  const pageVersion = "react_with_sso";

  return (
    <Providers
      emailRegex={emailRegex}
      treatmentPlanTerm={treatmentPlanTerm}
      currentCountry={currentCountry}
      flippers={flippers}
      e2e={e2e}
    >
      <ErrorBoundary {...{ flippers, csuid, roleId, storeId, pageVersion }}>
        <Pages
          patientAttributes={patientAttributes}
          additionalAttributes={additionalAttributes}
          csuid={`${csuid}`}
          pageVersion={pageVersion}
          newSSOErrors={newSSOErrors}
          isPreview={isPreview}
          isStoreOwner={isStoreOwner}
          storeId={storeId}
        />
      </ErrorBoundary>
    </Providers>
  );
};

export { StoreLandingEntryPoint };
